<template>
  <div class="chat-container" ref="chatContainer" @scroll="handleScroll()">
    <div class="chat-list" ref="chatList">
      <div v-for="(item, index) in messages" :key="index" class="chat-item-box">
        <div
          class="chat-item chat-item-notify"
          v-if="item.action === 'userEnterSeat'"
        >
          <div class="user-level-wrap">
            <div
              class="userlevel-tag"
              v-if="item.level"
              :class="`level-${item.level}`"
            ></div>
          </div>
          <span class="nickname">{{ item.nickName }}</span>
          {{ item.message }}
        </div>
        <div
          class="chat-item chat-item-notify"
          v-if="item.action === 'userJoinRoom'"
        >{{$t('components_voiceroom_component_chat_message_1839')}}<div class="user-level-wrap">
            <div
              class="userlevel-tag"
              v-if="item.level"
              :class="`level-${item.level}`"
            ></div>
          </div>
          <span class="nickname">{{ item.nickName }}</span>
          {{ item.message }}
        </div>
        <div
          class="chat-item chat-item-notify chat-item-system-message"
          v-if="item.action === 'systemMessage'"
        >
          {{ item.message }}
        </div>
        <div
          class="chat-item chat-item-notify"
          v-if="item.action === 'leaveRoom'"
        >
          <div class="user-level-wrap">
            <div
              class="userlevel-tag"
              v-if="item.level"
              :class="`level-${item.level}`"
            ></div>
          </div>
          <span class="nickname">{{ item.nickName }}</span>
          {{ item.message }}
        </div>
        <p
          class="chat-item chat-item-notify chat-item-gift-send"
          v-else-if="item.action === 'OnSendGift'"
        >
          <template v-if="item.giftInfo.boxType === 'DynamicState'">
            <span class="nickname">{{ item.nickName }}</span>
            <span>{{$t('components_voiceroom_component_chat_message_1840')}}</span>
            <span class="nickname">{{ item.message }}</span>
            <span
              >{{ item.giftInfo.giftName }}*{{
                item.giftInfo.totalBoxCount
              }}，</span
            >
            <span style="padding-left: 4px">{{$t('components_voiceroom_component_chat_message_1841')}}</span>
            <img :src="item.giftInfo.boxGiftLst[0].boxImageUrl" alt="" />
            <span> * {{ item.giftInfo.giftCount }} </span>
          </template>
          <template v-if="item.giftInfo.boxType != 'DynamicState'">
            <span class="nickname">{{ item.nickName }}</span>
            <span>{{$t('components_voiceroom_component_chat_message_1842')}}</span>
            <span class="nickname">{{ item.message }}</span>
            <img :src="item.giftInfo.boxGiftLst[0].boxImageUrl" alt="" />
            <span> * {{ item.giftInfo.giftCount }} </span>
          </template>
        </p>
        <div
          class="chat-item chat-item-notify chat-item-gift-send"
          v-else-if="item.action === 'openBox'"
        >
          <span class="nickname">{{ item.nickName }}</span>
          <span>{{$t('components_voiceroom_component_chat_message_1843')}}</span>
          <img :src="item.giftInfo.giftImageUrl" alt="" />
          <span> * {{ item.giftInfo.totalBoxCount }}，</span>
          <!-- <span class="nickname">{{ item.giftInfo.playerNickname }}</span> -->
          <span v-if="item.giftInfo.boxGiftLst[0].orderDesc === '999'"
            >{{$t('components_voiceroom_component_chat_message_1844')}}</span
          >
          <span>{{$t('components_voiceroom_component_chat_message_1845')}}</span>
          <img :src="item.giftInfo.boxGiftLst[0].boxImageUrl" alt="" />
          <span> * {{ item.giftInfo.giftCount }} </span>
        </div>
        <div
          class="chat-item chat-item-text"
          v-else-if="item.action === 'normal'"
        >
          <div class="avatar-box">
            <img
              class="avatar"
              :src="$util.setImageSize(item.userInfo.avatarURL, 100, 100)"
              alt=""
            />
            <img
              class="avatar-frame"
              :src="getAvatarFrame(item.userInfo.userUuid)"
              alt=""
              v-if="getAvatarFrame(item.userInfo.userUuid)"
            />
          </div>
          <div class="right">
            <div class="top">
              <div class="user-level-wrap">
                <div
                  class="userlevel-tag"
                  v-if="item.level"
                  :class="`level-${item.level}`"
                ></div>
              </div>
              <img
                class="img-title"
                :src="formatUrl(item.dressup.TITLE.url)"
                alt=""
                v-if="
                  item.dressup && item.dressup.TITLE && item.dressup.TITLE.url
                "
              />
              <span class="nickname">{{ item.nickName }}</span>
              <img
                class="img-pendant"
                :src="formatUrl(item.dressup.PENDANT.url)"
                alt=""
                v-if="
                  item.dressup &&
                    item.dressup.PENDANT &&
                    item.dressup.PENDANT.url
                "
              />
            </div>
            <div
              class="bottom"
              :class="{
                'has-dressup': item.dressup && item.dressup.BUBBLE_BOX
              }"
              :style="
                item.dressup &&
                item.dressup.BUBBLE_BOX &&
                item.dressup.BUBBLE_BOX.url
                  ? {
                      'border-image-source': `url(${formatUrl(item.dressup.BUBBLE_BOX.url)})`
                    }
                  : ''
              "
            >
              {{ item.message }}
            </div>
          </div>
        </div>
        <div
          class="chat-item chat-item-image"
          v-else-if="item.action === 'imageReceive'"
        >
          <div class="avatar-box">
            <img
              class="avatar"
              :src="$util.setImageSize(item.userInfo.avatarURL, 100, 100)"
              alt=""
            />
            <img
              class="avatar-frame"
              :src="getAvatarFrame(item.userInfo.userUuid)"
              alt=""
              v-if="getAvatarFrame(item.userInfo.userUuid)"
            />
          </div>
          <div class="right">
            <div class="top">
              <div class="user-level-wrap">
                <div
                  class="userlevel-tag"
                  v-if="item.level"
                  :class="`level-${item.level}`"
                ></div>
              </div>
              <img
                class="img-title"
                :src="formatUrl(item.dressup.TITLE.url)"
                alt=""
                v-if="
                  item.dressup && item.dressup.TITLE && item.dressup.TITLE.url
                "
              />
              <span class="nickname">{{ item.nickName }}</span>
              <img
                class="img-pendant"
                :src="formatUrl(item.dressup.PENDANT.url)"
                alt=""
                v-if="
                  item.dressup &&
                    item.dressup.PENDANT &&
                    item.dressup.PENDANT.url
                "
              />
            </div>
            <div class="bottom">
              <el-image
                class="img"
                :src="item.message"
                :preview-src-list="[item.message]"
                fit="contain"
              >
              </el-image>
            </div>
          </div>
        </div>
        <div
          class="chat-item chat-item-image chat-item-emoji"
          v-else-if="item.action === 'emojiReceive'"
        >
          <div class="avatar-box">
            <img
              class="avatar"
              :src="$util.setImageSize(item.userInfo.avatarURL, 100, 100)"
              alt=""
            />
            <img
              class="avatar-frame"
              :src="getAvatarFrame(item.userInfo.userUuid)"
              alt=""
              v-if="getAvatarFrame(item.userInfo.userUuid)"
            />
          </div>
          <div class="right">
            <div class="top">
              <div class="user-level-wrap">
                <div
                  class="userlevel-tag"
                  v-if="item.level"
                  :class="`level-${item.level}`"
                ></div>
              </div>
              <img
                class="img-title"
                :src="formatUrl(item.dressup.TITLE.url)"
                alt=""
                v-if="
                  item.dressup && item.dressup.TITLE && item.dressup.TITLE.url
                "
              />
              <span class="nickname">{{ item.nickName }}</span>
              <img
                class="img-pendant"
                :src="formatUrl(item.dressup.PENDANT.url)"
                alt=""
                v-if="
                  item.dressup &&
                    item.dressup.PENDANT &&
                    item.dressup.PENDANT.url
                "
              />
            </div>
            <div class="bottom">
              <el-image
                class="img"
                :src="item.emojiInfo.imageUrlList[0]"
                fit="contain"
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="new-message" v-if="hasNewMessage" @click="scrollChatToBottom()">
      <i class="el-icon-bottom"></i>{{$t('components_voiceroom_component_chat_message_1846')}}</div>
  </div>
</template>

<script>
import ChatProvider from '@/components/VoiceRoom/chatProvider';
import { formatAwsUrl } from '@/components/VoiceRoom/util';
import VoiceRoomIM from '@/components/VoiceRoom/voiceRoomIM';
import { mapGetters } from 'vuex';

export default {
  name: 'ChatMessage',
  computed: {
    ...mapGetters(['userInfo']),
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    messages() {
      return ChatProvider.messageList;
    }
  },
  data() {
    return {
      hasNewMessage: false,
      autoScroll: true,
      preScrollTop: 0,
      mChatProvider:ChatProvider
    };
  },
  watch: {
    messages: {
      handler: function() {
        if (!this.autoScroll) {
          this.showNewMessage();
        } else {
          this.scrollChatToBottom();
        }
      }
    }
  },
  methods: {
    handleScroll() {
      if (
        this.$refs.chatContainer.scrollTop +
          this.$refs.chatContainer.clientHeight >=
        this.$refs.chatList.scrollHeight
      ) {
        this.hasNewMessage = false;
      }
      if (!this.preScrollTop) {
        this.preScrollTop = this.$refs.chatContainer.scrollTop;
      }
      if (this.$refs.chatContainer.scrollTop < this.preScrollTop) {
        this.autoScroll = false;
      }
      this.preScrollTop = this.$refs.chatContainer.scrollTop;
    },
    showNewMessage() {
      if (
        this.$refs.chatContainer.scrollTop +
          this.$refs.chatContainer.clientHeight <
        this.$refs.chatList.scrollHeight + 40
      ) {
        this.hasNewMessage = true;
      }
    },
    // 滚动聊天内容区域到底部
    scrollChatToBottom() {
      this.$nextTick(() => {
        this.$refs.chatContainer.scrollTop =
          this.$refs.chatList.scrollHeight -
          this.$refs.chatContainer.clientHeight;
        this.hasNewMessage = false;
        setTimeout(() => {
          this.autoScroll = true;
        }, 0);
      });
    },
    formatUrl(url) {
      return formatAwsUrl(url);
    },
    getAvatarFrame(userId) {
      const res = VoiceRoomIM.getMemberPfpFrame(userId);
      return res ? res.url : '';
    },
    isOpenGift(giftInfo) {
      const { sendPlayerUserUuids } = giftInfo;
      return (
        sendPlayerUserUuids &&
        sendPlayerUserUuids.length === 1 &&
        sendPlayerUserUuids[0] === this.uuid
      );
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-container {
  overflow-y: auto;
  height: 1px;
  flex: auto;
  @include hideScrollBar(0, 0);
}

.new-message {
  position: absolute;
  right: 10px;
  bottom: 100px;
  color: #f42961;
  background-color: #fee3e9;
  padding: 10px 20px;
  border-radius: 16px;
  font-size: 12px;
}

.chat-list {
  padding: 10px 20px; /* 设置内边距 */
  font-size: 12px;
  color: white;

  .user-level-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .userlevel-tag {
    height: 18px;
    width: 40px;
    margin-right: 6px;
  }
}

.chat-item-box {
  margin-bottom: 22px; /* 设置消息之间的间距 */
  position: relative;
}
.chat-item-notify {
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 14px;

  .nickname {
    color: #99cde3 !important;
    padding: 0 4px;
  }
}
.chat-item {
  display: flex;
  align-items: flex-start;
  line-height: 1.4;
  flex-wrap: wrap;
  .avatar-box {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: 20px;
    flex: none;
  }
  .avatar {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
  .avatar-frame {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1.43);
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }
  .top {
    display: flex;
    align-items: center;
  }
  .bottom {
    display: flex;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-all;
  }
  .nickname {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
  }
}
.chat-item-text {
  .bottom {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-sizing: border-box;
    max-width: 200px;
    // margin-right: 15px;
    padding: 8px 14px;
    margin-top: 7px;
    display: inline-block;
    &.has-dressup {
      border-width: 5px;
      border-style: solid;
      border-color: transparent;
      border-image-repeat: initial;
      border-image-outset: 4px 7px;
      border-image-slice: 70 82 58 70 fill;
      border-image-width: 30px;
      text-shadow: 0 0px 18px black;
    }
  }
}
.chat-item-image {
  .bottom {
    background-color: rgba(225, 225, 225, 0.1);
    display: flex;
    align-items: center;
    width: 120px;
    height: 80px;
    padding: 10px;
    border-radius: 8px;
    margin-top: 7px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.chat-item-emoji {
  .bottom {
    background-color: rgba(225, 225, 225, 0.1);
    display: flex;
    align-items: center;
    width: 70px;
    height: 72px;
  }
}
// .chat-item-gift-box {
//   .bottom {
//     background-color: #fee3e9;
//     display: flex;
//     align-items: center;
//     padding: 10px;
//     border-radius: 8px;
//     margin-top: 7px;
//     flex-wrap: wrap;
//     span {
//       flex: none;
//     }

//     .nickname {
//       color: #f42961;
//       padding: 4px;
//     }
//     img {
//       width: 20px;
//       height: auto;
//     }
//   }
// }
.chat-item-gift-send {
  // background-color: #fee3e9;
  align-items: center;
  color: white;
  img {
    width: 32px;
    height: auto;
    margin: 0 2px 0;
  }
  .nickname {
    color: #f42961 !important;
  }
}
.chat-item-system-message {
  // color: #f42961;
  // background-color: #fee3e9;
  align-items: center;
}
.img-title {
  height: 16px;
  width: auto;
}
.img-pendant {
  height: 16px;
  width: auto;
}
.top {
  flex-wrap: wrap;
}
.nickname,
.img-title {
  margin-right: 4px;
}
</style>
